<template>
  <div class="mainscreen">
     <EditItem v-model="modalEditItem" v-bind:rect="selectedRect" v-on:edited="onCloseDialog" v-on:deleted="onDeleteLabel"></EditItem>
     <EditDice v-model="modalEditDice" v-bind:rect="selectedRect" v-on:edited="onCloseDialog" v-on:deleted="onDeleteLabel"></EditDice>
     <EditCounter v-model="modalEditCounter" v-bind:rect="selectedRect" v-on:edited="onCloseDialog" v-on:deleted="onDeleteLabel"></EditCounter>
     <EditDeck v-model="modalEditDeck" v-bind:rect="selectedRect" v-on:edited="onCloseDialog" v-on:deleted="onDeleteLabel"></EditDeck>
  	<div class="menubar">
    	
    	<span class="menuitem" v-if="helppage && started"><button id="rejoin" v-on:click="fetchLatest">Rejoin</button></span>
    	<span class="menuitem leftmenu">
    		<b-button v-b-toggle.sidebar-deck>Card area <img style="height:16px" src="../assets/arrowdown.png"/></b-button>
    		<img v-if="newimage" class="clickable" src="../assets/downloading.png" title="Downloading the latest image"/>
    		<img v-if="!newimage" class="clickable" src="../assets/download.png" title="Download the latest image (should be automatic)" v-on:click="fetchLatest"/>
    		<span class="menutext" title="Seconds since the last image was loaded"> {{lastImage}} </span>
    		
    	</span>
    	
    	<span class="menuitem">
    		<img class="padded clickable" src="../assets/zoomin.png" title="Make the image smaller by a set amount (also: double click)" v-on:click="zoomIn">
    		<img class="padded clickable" src="../assets/zoomout.png" title="Move the image larger by a set amount (also: single click)" v-on:click="zoomOut">
    	</span>
    	<span class="menuitem">
    		<img class="padded clickable" src="../assets/arrowleft.png" title="Move the image left by a set amount" v-on:click="panLeft">
    		<img class="padded clickable" src="../assets/arrowright.png" title="Move the image right by a set amount" v-on:click="panRight">
    		<img class="padded clickable" src="../assets/arrowup.png" title="Move the image up by a set amount" v-on:click="panUp">
    		<img class="padded clickable" src="../assets/arrowdown.png" title="Move the image down by a set amount" v-on:click="panDown">
    	</span>  
    	  		
    	<span class="menuitem">
    		<img class="padded clickable" src="../assets/rotateclockwise.png" title="Rotate the image clockwise by 90 degrees" v-on:click="rotateImage"/>
    		<img class="padded clickable" src="../assets/rotateanticlockwise.png" title="Rotate the image anticlockwise by 90 degrees" v-on:click="rotateImageAnti"/>
    	</span>
    	<span class="menuitem">
    		<img class="padded clickable" src="../assets/reload.png" title="Undo any rotation, panning or zooming" v-on:click="resetZoom"/>  	
    	</span>
    	
    	<span class="menuitem">
    		<img v-if="drawMode=='pen'" class="padded clickable" src="../assets/draw_on.png" title="Stop drawing" v-on:click="setDrawMode('')"/>	
    		<img v-if="drawMode!='pen'" class="padded clickable" src="../assets/draw_off.png" title="Start drawing (or right mouse button)" v-on:click="setDrawMode('pen')"/>	
    		<img class="padded clickable" src="../assets/clear.png" title="Clear all drawings (for everyone)" v-on:click="clearDrawing"/>	
    	</span>
    
    	<span class="menuitem">
    		<img v-if="drawMode!='label'" class="padded clickable" src="../assets/case_off.png" title="Add an item" v-on:click="setDrawMode('label')"/>	    		
    		<img v-if="drawMode=='label'" class="padded clickable" src="../assets/case_on.png" title="Click to place an item on the board" v-on:click="setDrawMode('')"/>	
    		<img v-if="drawMode!='dice'" class="padded clickable" src="../assets/dice_off.png" title="Add a dice" v-on:click="setDrawMode('dice')"/>	    		
    		<img v-if="drawMode=='dice'" class="padded clickable" src="../assets/dice_on.png" title="Click to place a dice on the board" v-on:click="setDrawMode('')"/>
    		<img v-if="drawMode!='counter'" class="padded clickable" src="../assets/counter_off.png" title="Add a counter" v-on:click="setDrawMode('counter')"/>	    		
    		<img v-if="drawMode=='counter'" class="padded clickable" src="../assets/counter_on.png" title="Click to place a counter on the board" v-on:click="setDrawMode('')"/>	
    		<img v-if="drawMode!='deck'" class="padded clickable" src="../assets/deck_off.png" title="Add a deck" v-on:click="setDrawMode('deck')"/>	    		
    		<img v-if="drawMode=='deck'" class="padded clickable" src="../assets/deck_on.png" title="Click to place a deck on the board" v-on:click="setDrawMode('')"/>	
    	</span>
    
    
    	<span class="menuitem rightmenu">
    		<b-button v-b-toggle.sidebar-player>Player area <img style="height:16px" src="../assets/arrowdown.png"/></b-button>
    	</span>
    	<span class="menuitem rightmenu" v-on:click="onLeave">
    			<img v-if="connectionStatus=='OK'" src="../assets/connected.png" title="Connection is good. Click to disconnect"/>  
    			<img v-if="connectionStatus=='closed'" src="../assets/disconnected.png" title="Connection lost. Click to leave"/>  
    			<img v-if="connectionStatus!='OK' && connectionStatus!='closed'" src="../assets/connecting.png" title="Connecting to the server. Click to cancel"/>  	
    	</span>
    	
    	
    
    </div>   
    <canvas id="canvas" ref=device></canvas>
    
    
    <b-modal id="bv-modal-preset" title="Pick a preset" @ok="applyPreset">    	
    	<form ref="form">
      	  <b-form-select block id="presetFilter" v-model="selectedFilter" text="Game" class="m-md-2" menu-class="w-100">
          	<b-form-select-option value='mom'>Mansions of Madness</b-form-select-option>
		    <b-form-select-option value='lotr'>Lord of the Rings</b-form-select-option>
		    <b-form-select-option value='si'>Spirit Island</b-form-select-option>	    	    
          </b-form-select>
    	
    	  <span v-if="selectedFilter=='mom'">  
	          <b-form-select block id="presetDropdown" v-model="selectedPreset" text="Preset" class="m-md-2" menu-class="w-100">
	            <b-form-select-option :value="null" disabled>Please select an option</b-form-select-option>
			    <b-form-select-option value='Charlie Kane'>Charlie Kane (The politician)</b-form-select-option>
			    <b-form-select-option value='Wendy Adams'>Wendy Adams (The urchin)</b-form-select-option>
			    <b-form-select-option value='Preston Fairmont'>Preston Fairmont (The millionaire)</b-form-select-option>
			    <b-form-select-option value='Carson Sinclair'>Carson Sinclair (The butler)</b-form-select-option>
			    <b-form-select-option value='Agatha Crane'>Agatha Crane (The parapsychologist)</b-form-select-option>
			    <b-form-select-option value='Rita Young'>Rita Young (The athelete)</b-form-select-option>
			    <b-form-select-option value='Minh Thi Phan'>Minh Thi Phan (The secretary)</b-form-select-option>
			    <b-form-select-option value='William Yorick'>William Yorick (The gravedigger)</b-form-select-option>
			    <b-form-select-option value='Lily Chen'>Lily Chen (The martial artist)</b-form-select-option>
			    <b-form-select-option value='Father Mateo'>Father Mateo (The priest)</b-form-select-option>
			  </b-form-select>
		  </span>
    	  <span v-if="selectedFilter=='lotr'">  
	          <b-form-select block id="presetDropdown" v-model="selectedPreset" text="Preset" class="m-md-2" menu-class="w-100">
			    <b-form-select-option value='Frodo'>Frodo (2+ players)</b-form-select-option>
			    <b-form-select-option value='Sam'>Sam (2+ players)</b-form-select-option>
			    <b-form-select-option value='Pippin'>Pippin (3+ players)</b-form-select-option>
			    <b-form-select-option value='Merry'>Merry (4+ players)</b-form-select-option>
			    <b-form-select-option value='Fatty'>Fatty (5+ players)</b-form-select-option>
			  </b-form-select>
		  </span>
		  <span v-if="selectedFilter=='si'">  
	          <b-form-select block id="presetDropdown" v-model="selectedPreset" text="Preset" class="m-md-2" menu-class="w-100">
			    <b-form-select-option value='green'>A spread of rampant green</b-form-select-option>
			    <b-form-select-option value='river'>River surges in sunlight</b-form-select-option>
			    <b-form-select-option value='nightmare'>Bringer of dreams and nightmares</b-form-select-option>
			    <b-form-select-option value='ocean'>Ocean's hungry grasp</b-form-select-option>
			    <b-form-select-option value='thunderspeaker'>Thunderspeaker</b-form-select-option>			
			    <b-form-select-option value='earth'>Vital strength of the earth</b-form-select-option>
			    <b-form-select-option value='shadows'>Shadows flicker like flame</b-form-select-option>
			    <b-form-select-option value='lightning'>Lightning's swift strike</b-form-select-option>		    
			  </b-form-select>
		  </span>
    		            
      </form>
    <div class="mt-2" v-if="selectedPreset!=null">Press OK to load the preset for <strong>{{ selectedPreset }}</strong></div>
  </b-modal>
    
    <b-sidebar id="sidebar-player" right shadow width=25%  :title="selectedUserId + '\'s player area'">
	      <div class="px-3 py-2">
	      	<span v-if="playerData">
	      	</span>
	        <span v-if="!playerData">Add a <b-button v-on:click="showPresetDialog">Preset</b-button> or add things manually below<br/>
	      	</span>
	      
	      	<span class="lead" v-on:click="selectedRect = makeNewRect(); selectedRect.type='counter'; modalEditCounter=true;">Counters <b-button variant="light"><b-icon icon="plus"></b-icon></b-button></span>
	          <b-card-group columns>
	          	<b-card v-for="item in rectangles" :key="item.id" v-if="item.type == 'counter' && item.location=='player' && item.owner==selectedUserId">
		         	<template v-slot:header>
	        			<b-button block v-on:click="selectedRect=item;modalEditCounter=true;">{{item.label}}</b-button>      			
	      			</template>
	         		<b-card-text>
	         			{{item.count}}<span v-if="item.limit">/{{item.limit}}</span>
	         		</b-card-text>
	         		<template v-slot:footer>
	         			<b-button variant="success" v-on:click="incrementCounter(item)">+</b-button>
	        			<b-button variant="danger" v-on:click="decrementCounter(item)">-</b-button>
 					</template>
	         	</b-card>
	          </b-card-group>
	        <span class="lead" v-on:click="selectedRect = makeNewRect(); selectedRect.type='dice'; modalEditDice=true;">Dice<b-button variant="light"><b-icon icon="plus"></b-icon></b-button></span>	        
	          <b-card-group columns>
	         	<b-card v-for="item in rectangles" :key="item.id" v-if="item.type == 'dice' && item.location=='player' && item.owner==selectedUserId">
	         		<template v-slot:header>
	        			<b-button block v-on:click="selectedRect=item;modalEditDice=true;">{{item.label}}</b-button>      			
	      			</template>
	         		<b-card-text>
	         			{{item.numDice}} dice
	         		</b-card-text>
	         		<template v-slot:footer>
	         			<b-button block variant="success" v-on:click="rollDice(item)">Roll</b-button>
	        		</template>
	         	</b-card>
	          </b-card-group>
	          <span class="lead" v-on:click="selectedRect = makeNewRect(); selectedRect.type='deck'; modalEditDeck=true;">Deck<b-button variant="light"><b-icon icon="plus"></b-icon></b-button></span>	        
	          <b-card-group columns>
	         	<b-card v-for="item in rectangles" :key="item.id" v-if="item.type == 'deck' && item.location=='player' && item.owner==selectedUserId">
	         		<template v-slot:header>
	        			<b-button block v-on:click="selectedRect=item;modalEditDeck=true;">{{item.label}}</b-button>      			
	      			</template>
	         		<b-card-text>
	         			<span v-on:click="selectedRect=item;" v-b-toggle="'sidebar-deck'">{{item.count}}</span> 
	         		</b-card-text>
	         		<template v-slot:footer>
	         			<span v-if="item.cardsDrawn!='0' && item.cardsDrawn!='pick'">
	         				<b-button block variant="success" v-on:click="drawCard(item)">Draw</b-button>
	         			</span>
	         			<span v-if="item.viewMode!='never'">
	         				<b-button block variant="success" v-on:click="viewDeck(item)">View</b-button>	  
	         			</span>       			
	        		</template>
	         	</b-card>
	          </b-card-group>
	          <span class="lead" v-on:click="selectedRect = makeNewRect(); selectedRect.type='label'; modalEditItem=true;">Items<b-button variant="light"><b-icon icon="plus"></b-icon></b-button></span>	        
	          <b-card-group columns>
	         	<b-card v-for="item in rectangles" :key="item.id" v-if="item.type == 'label' && item.location=='player' && item.owner==selectedUserId">
	         		<template v-slot:header>
	        			<b-button block v-on:click="selectedRect=item;modalEditItem=true;">{{item.label}}</b-button>      			
	      			</template>
	         		<b-card-text>
	         			<span class="card-text-description">{{item.description}}</span>
	         		</b-card-text>
	         		<template v-slot:footer>
	         			<b-button block variant="success" v-on:click="item.location='board';sendCommand('updaterectangle', item);redrawCanvas();">Drop</b-button>
	        		</template>
	         	</b-card>
	          </b-card-group>
	      </div>
	      <span v-if="playerData" style="float:right; margin-right:20px;">
	      <b-button v-on:click="onDeleteAllPlayerData" variant="warning">
	      	<b-icon  icon="exclamation-triangle-fill"></b-icon>
	        	Delete all
			</b-button>
		  </span>
		  		  
    	</b-sidebar>
    	
    	<b-sidebar id="sidebar-deck" left shadow v-bind:width="currentdeck.width?(currentdeck.width + 40).toString()+'px':'200px'" :title="currentdeck?currentdeck.label : 'No deck selected'">
	    	<b-button v-if="currentdeck && currentdeck.deckUse=='discard'" block variant="info" v-on:click="sendCommand('reclaimdeck', currentdeck.id)">Reclaim all</b-button>
	    	<span v-if="currentdeck && selectedRect && selectedRect.type=='deck'"></span>
	    		  <!--div class="px-1 py-1"-->
	    		  
	    		  <b-card-group deck>	    		  
	    		  <draggable :list="currentdeck.cards">
	         		<b-card bg-variant="light"  v-for="(card,index) in currentdeck.cards" :key="card.id" >
		    		   <template v-slot:header>
		        			<b-button block>{{card.label}}&nbsp; 
		        			<img v-if="selectedRect && selectedRect.discardGoTo!='none'" v-on:click="sendCommand('discardcard', card, currentdeck.id)" style="width:16px" src="../assets/bin.png"/></b-button>
		        		</template>
		         		<b-card-text>
		         		<span v-if="card.description" class="card-text-description">{{card.description}}</span>		         		
		         		<span>			         		
		         			<img v-if="card.url" v-bind:width="currentdeck.width + 'px'" v-bind:src="imageServerURL + card.url"/>
		         		</span>
		         		</b-card-text>
		         		<template v-slot:footer>
	         				<b-button block variant="success" v-on:click="sendCommand('playcard', card, currentdeck.id);">Play</b-button>
	         				
	        		</template>
		         	</b-card>
  	          	</draggable>
  	          	</b-card-group>	          
		      <!--/div -->	       
    	</b-sidebar>
  </div>
  
  
</template>

<script>
var gkhead= new Image;
var gkPreload= new Image;
var ws;
var self;
var ctx;
var canvas;

import EditItem from './EditItem.vue'
import EditDice from './EditDice.vue'
import EditCounter from './EditCounter.vue'
import EditDeck from './EditDeck.vue'
import draggable from 'vuedraggable'

export default {
  name: 'MainScreen',
   components: {
    EditItem,
    EditDice,
    EditCounter,
    EditDeck,
    draggable
  },
  props: {
  	
  },
  data:  function () {
    return {
      connectionStatus: 'ready',
      lastImage:0,
      started:false,
      helppage:true,
      newOrientation:0,
      orientation:0,
      currentRotation:0,
      host:"",
      newimage:false,
      drawMode:"",
      lines:[],
      rectangles:[],
      shouldConnect:true,
      modalEditItem: false,
      modalEditDice: false,
      modalEditCounter:false,
	  modalEditDeck: false,
      rectBeingMoved:null,
      selectedRect:null,
      playerData:false,
      selectedPreset:"Frodo",
      selectedFilter:"lotr",
      currentdeck:{},
      imageServerURL:"",
      selectedUserId: this.$parent.userId
    }
  },
  computed:{	 
  },
  mounted:function(){
  		console.log("Running in: " + process.env.NODE_ENV);
   		self = this;
   		self.shouldConnect=true;
   		
   		// Where are our static images? Not part of the main app to keep deploy sizes sane
   		self.imageServerURL =   "http://" + window.location.host + "/images/";
   		// Local dev only!
		if (process.env.NODE_ENV === "development") self.imageServerURL =  "http://localhost:8079/images/";
   		
   		
   		console.log('Mounted, self=' + self);
   		gkPreload.onload = function(){
   			// We preload into this image, so that there's no delay when getting gkhead to load - it should grab directly from image cache
   			// If you don't do this then the download delay from setting gkhead.src to gkhead.onload firing means the canvas is blank when redrawing
   			gkhead.src = gkPreload.src;
   		},
   		gkhead.onload = function(){
   			// Image has loaded, tell the canvas to reload
   			self.lastImage=0;	
   			// Work out what the rotation should be from the change in orientation
   			// NOTE that this may all now be obsolete as I am stripping any orientation data from the image in the server
   			var rotation = self.orientationToRotation(self.newOrientation) - self.orientationToRotation(self.orientation)
   			ctx.translate(canvas.width,canvas.height);
   			ctx.rotate(rotation*Math.PI/180);
  			ctx.translate(-canvas.width,-canvas.height);
   			console.log("Image '" + gkhead.src + "' loaded with autorotate: " + rotation)
  			self.redrawCanvas();
   			self.orientation = self.newOrientation
   			self.newimage=false;	
   		}
		gkhead.src = self.getInitialImgUrl();
        self.loadCanvas() // will execute at pageload
        setTimeout(() => {
				console.log('start first connection this=' + this);	
				self.openWebsocket();
				self.redrawCanvas();
				self.imageTimer();
			}, 1000);
  },
  methods: {
  	applyPreset:function(bvModalEvt)
  	{
  		if (this.selectedPreset){
	  		self.sendCommand("preset",this.selectedPreset)	
	  		this.doToast(this.$parent.userId + ' selected ' + this.selectedPreset);
	  	}		
  	},
  	setDrawMode:function(newMode)
  	{
  		self.drawMode = newMode;
  		if (self.drawMode == "pen"){
  		 	document.getElementById("canvas").style.cursor = "crosshair"; 
  		} 
  		else if (self.drawMode == "label" || self.drawMode == "dice" || self.drawMode == "counter" || self.drawMode=="deck"){
  			document.getElementById("canvas").style.cursor = "pointer";
  		}
  		else
  		{
  			document.getElementById("canvas").style.cursor = "auto"; 	
  		}
  	},
  	onLeave:function(){
  		self.sendCommand("leave","")
  		this.shouldConnect=false;
  		ws.close(); 
  		self.$emit('authfail');
  	},
  	onCloseDialog : function(rect){
  		self.sendCommand("updaterectangle", rect);
  		//self.selectedRect = null;
  		if (self.selectedRect)
  		{
  			if (self.selectedRect.type=="deck")
  				self.selecteddeck = self.selectedRect;
  		}
  		self.redrawCanvas();
  	},
  	onCloseDeckDialog : function(rect){	
  		self.sendCommand("createdeck", rect);
  		self.selectedRect = null;
  		self.redrawCanvas();
  	},
  	onDeleteAllPlayerData : function(){
  	var i = self.rectangles.length
		while (i--) {
  			var  rect = self.rectangles[i];
  			if (rect.location=="player"){
  				this.onDeleteLabel(rect);
  			}
  		}	
  	},
  	onDeleteLabel : function(rectToDelete) {	
  		self.sendCommand("deleterectangle", rectToDelete.id);
  		self.selectedRect = null;
  		var index = self.rectangles.findIndex(rect => rect.id == rectToDelete.id);
  		if (index > -1){
  			self.rectangles.splice(index,1)
		}
		self.redrawCanvas();
  	},
    clearDrawing : function() {
    	self.sendCommand("cleardrawing", "")
    	self.lines = [];
    	// Don't clear the rectangles
    	self.redrawCanvas();
    },    
    orientationToRotation: function(o) {
    // The server tells you what it thinks the orientation should be. 
    // This is from the image EXIF "orientation", *which has been removed* as some browsers also look at that - so it happens twice
    	if (o==6) return 90;
    	if (o==3) return 180;
    	if (o==8) return 270;
    	return 0;
    },
    imageTimer: function() {
            setTimeout(() => {
                this.lastImage += 1
                this.imageTimer()
            }, 1000)        
    },
  	fetchLatest: function(event) {
  		self.newimage = true;
  		ws.send('{"command":"rebroadcast", "user":"' + self.$parent.userId + '", "game":"' + self.$parent.gameId + '"}');	
  	},
  	rotateImage: function(event) {
  		ctx.translate(canvas.width,canvas.height);
  		ctx.rotate(90*Math.PI/180);
  		ctx.translate(-canvas.width,-canvas.height);
  		self.redrawCanvas();
  		self.currentRotation += 90;
  		if (self.currentRotation >=360){
  			self.currentRotation = 0;
  		}
  		self.redrawCanvas();
  		
  	},
  	rotateImageAnti: function(event) {
  		ctx.translate(canvas.width,canvas.height);
  		ctx.rotate(-90*Math.PI/180);
  		ctx.translate(-canvas.width,-canvas.height);
  		self.redrawCanvas();
  		self.currentRotation -= 90;
  		if (self.currentRotation <0){
  			self.currentRotation = 270;
  		}
  		self.redrawCanvas();
  	},
  	panRight: function(event) {
        ctx.translate(100,0);
        self.redrawCanvas();
  	},
  	panLeft: function(event) {
        ctx.translate(-100,0);
        self.redrawCanvas();
  	},
  	panUp: function(event) {
        ctx.translate(0,-100);
        self.redrawCanvas();
  	},
  	panDown: function(event) {
        ctx.translate(0, 100);
        self.redrawCanvas();
  	},
  	zoomIn: function(event) {
  		ctx.scale(0.9,0.9);
        self.redrawCanvas();  	
  	},
  	zoomOut: function(event) {
  		ctx.scale(1.1,1.1);
        self.redrawCanvas();  	
  	},
  	resetZoom: function(event) {
  		ctx.setTransform(1, 0, 0, 1, 0, 0);
  		self.currentRotation = 0;
  		self.redrawCanvas();
  	},
   	openWebsocket: function () {
   		var protocol = "ws:"
   		if (window.location.protocol=="https:")
   			var protocol = "wss:";
   		
   		var serverURL =  protocol + "//" + window.location.host + "/atoroserver/client";
		// Local dev only!
		if (process.env.NODE_ENV === "development") serverURL =  "ws://localhost:8079/atoroserver/client";
		
		console.log("Connecting to " + serverURL);	
		this.connectionStatus="connecting..."
		ws = new WebSocket(serverURL);		        
        
        ws.onopen = function()
		{
			// Web Socket is connected, try to register ourselves automatically
			ws.send('{"command":"connect", "user":"' + self.$parent.userId + '", "game":"' + self.$parent.gameId + '"}');
			console.log("connection established ...");
			self.connectionStatus="OK"
		};
	
		ws.onmessage = function(event) {	
			console.log("message received : " + event.data);
			var data = JSON.parse(event.data);
			if (data.command=="redraw")
			{
				// New image is ready, tell the canvas to download it
				self.started = true;
				self.helppage= false;
				var newImg = window.location.protocol + "//" + window.location.host + "/atoroserver/upload/" + self.host + data.src;
				// Local dev only!
				if (process.env.NODE_ENV === "development") newImg = "http://localhost:8079/atoroserver/upload/" + self.host + data.src;
				console.log("New image available: " + newImg);			
				self.newOrientation = data.orientation;
				// NOTE that I load into a dummy "preload" image first as each image can take a few seconds to download
				gkPreload.src = newImg;	
			}
			if (data.command=="started")
			{
				self.started = data.value;
				self.host = data.host;			
				self.$toast.open("Welcome to " + data.game + " hosted by " + data.host);  
			}
			if (data.command=="toast")
			{
				self.$toast.open(data.toast);  				
			}
			if (data.command=="viewdeck")
			{
				self.currentdeck = data.data;
				// TODO! Work out how to open sidebar programmatically
				//self.$toast.open(data.toast);  				
			}
			if (data.command=="cards")
			{
				var card = data.data;
				var toast = {"type":"error", "duration":60000, "message":data.user + ' drew ' + card.label + " [" + card.description + "]"};	
				self.$toast.open(toast);  				
			}
			if (data.command=="newimage")
			{
				// It's being processed, we'll get a redraw when it's ready - tell the user it's coming
				self.newimage = true;
				self.lastImage=0;
			}
			if (data.command=="noauth")
			{
				self.host="";
				self.$emit('authfail')
			}
			if (data.command=="connected")
			{
				self.$toast.open(data.name + ' has joined');
			}
			if (data.command=="leave")
			{
				self.$toast.open({ message: data.name + ' has left', type:'error'});
			}
			if (data.command=="draw")
			{
				//console.log("Pushing line" + JSON.stringify(data.data));
				if (self.lines.length > 1000)
				{
					// Drop the first (i.e. oldest) lines
					self.lines.splice(0,self.lines.length-1000)
				}
				self.lines.push(data.data);
				self.redrawCanvas();
			}
			if (data.command=="rectangle")
			{
				// If this is an existing rectangle, delete the old one
				var index = self.rectangles.findIndex(rect => rect.id == data.data.id);
		  		if (index > -1){
		  			self.rectangles.splice(index,1)
				}
				//console.log("Pushing rectangle" + JSON.stringify(data.data));
				if (self.rectangles.length > 50)
				{
					// Drop the first (i.e. oldest) ones
					self.rectangles.splice(0,self.rectangles.length-50)
				}
				// TODO: Make these unique based on data.data.label
				// TODO: Work out how to age out old labels if they're no longer present
				self.rectangles.push(data.data);
				self.redrawCanvas();
			}
			if (data.command=="deleterectangle")
			{
				var index = self.rectangles.findIndex(rect => rect.id == data.id);
		  		if (index > -1){
		  			self.rectangles.splice(index,1)
				}
				self.redrawCanvas();
			}
			if (data.command=="cleardrawing")
			{
				self.lines = [];
		    	self.redrawCanvas();		
			}
		}   
		
		ws.onclose = function(){	
			if (self.shouldConnect)
			{
				console.log('Connection closed; reconnecting auto');
				self.connectionStatus="closed"
				setTimeout(() => {
					self.openWebsocket();
				}, 5000);
			}	
		}
        console.log("Finished connecting to " + serverURL + ", ws:" + ws);	        
    },
  	getInitialImgUrl: function()
  	{
  		// What's the default image to load, before joining a game?
  		// require means it will be included with webpack
  		return require('../assets/atoro.png')
  	},
  
    redrawCanvas: function(){

          // Clear the entire canvas
          var p1 = ctx.transformedPoint(0,0);
          var p2 = ctx.transformedPoint(canvas.width,canvas.height);
          ctx.clearRect(p1.x,p1.y,p2.x-p1.x,p2.y-p1.y);

          ctx.save();
          ctx.setTransform(1,0,0,1,0,0);
          ctx.clearRect(0,0,canvas.width,canvas.height);
          ctx.restore();

		  // Put in the main background image
	      ctx.drawImage(gkhead,0,0);
          
          // Now put all the lines that I want drawn - 
          self.lines.forEach(self.drawLineObj)
          self.playerData=false;
          self.rectangles.forEach(self.drawRectangleObj)          

    },    
    drawLineObj: function(line){
    	self.drawLine(line.from, line.to, line.colour);
    },
    drawRectangleObj: function(rect){
    	if (rect.location == "player" && rect.owner == this.selectedUserId)
    	{
    		this.playerData=true;
    		return;
    	}	
    	// Always upright, please
		ctx.rotate(-self.currentRotation*Math.PI/180);	
		rect = self.rotateCoords(rect)		
    	
    	ctx.beginPath();
    	ctx.lineWidth = "6";
    	ctx.strokeStyle = "black";
    	if (rect.isBeingDragged)
    		ctx.strokeStyle = "green";
		ctx.rect(rect.x, rect.y, rect.width, rect.height)
    	ctx.fillStyle = "white";
		ctx.fill(); // draw it!
		ctx.stroke();
		
		if (rect.type=="label")
		{
			this.drawText(rect, rect.label + "\n" + rect.description, 30);
		}
    	else if (rect.type=="dice")
    	{
    		this.drawText(rect, rect.label+ "\n" + (rect.numDice?rect.numDice:'1') + ' dice', 60);    	
    	}
    	else if (rect.type == "counter")
    	{
    		
    		this.drawText(rect, rect.label + " " + (rect.count?rect.count:"0"), 100, "top");    	
    		// Put some buttons in...
    		ctx.beginPath();
    		ctx.lineWidth = "2";
	    	ctx.strokeStyle = "black";
			ctx.rect(rect.x + rect.width*0.05, rect.y + rect.height* 0.55, rect.width*0.4, rect.height * 0.4)
	    	ctx.fillStyle = "green";
			ctx.fill(); 
			ctx.stroke();   
			
			ctx.beginPath();
    		ctx.lineWidth = "2";
	    	ctx.strokeStyle = "black";
			ctx.rect(rect.x + rect.width*0.55, rect.y + rect.height* 0.55, rect.width*0.4, rect.height*0.4)
	    	ctx.fillStyle = "red";
			ctx.fill(); 
			ctx.stroke(); 		
    	}
    	else if (rect.type == "deck")
    	{		
    		this.drawText(rect, rect.label + " " + (rect.count?rect.count:"0"), 100, "top");    	
    		// Put some buttons in...
    		if (rect.cardsDrawn != "0" && rect.cardsDrawn != "pick")
    		{	    		
				ctx.beginPath();
	    		ctx.lineWidth = "2";
		    	ctx.strokeStyle = "black";
		    	var button = {...rect};
		    	button.x += rect.width*0.05;
		    	button.y += rect.height* 0.55;
		    	button.width *= 0.4
		    	button.height *= 0.4
				ctx.rect(button.x, button.y, button.width, button.height)
		    	ctx.fillStyle = "green";
				ctx.fill(); 
				ctx.stroke();   
				this.drawText(button, "draw", 30, "middle"); 
			}
			
			if (rect.viewMode != "never")
			{
				ctx.beginPath();
	    		ctx.lineWidth = "2";
		    	ctx.strokeStyle = "black";
		    	var button = {...rect};
		    	button.x += rect.width*0.55;
		    	button.y += rect.height* 0.55;
		    	button.width *= 0.4
		    	button.height *= 0.4
				ctx.rect(button.x, button.y, button.width, button.height)
		    	ctx.fillStyle = "red";
				ctx.fill(); 
				ctx.stroke();
				if (rect.cardsDrawn == "pick")
					this.drawText(button, "pick", 30, "middle"); 
				else
				   this.drawText(button, "view", 30, "middle"); 
			} 		
    	}
    	// And move back to previous rotation
    	ctx.rotate(self.currentRotation*Math.PI/180);	
    	
	},
	drawText: function(rect, text, fontsize, align)
	{
			ctx.fillStyle = "black";
			ctx.font = fontsize + "px Verdana";
			
			// Split multiline
			var lines = text.split(/\r?\n/);
			lines.forEach((line,index) => {
				var offset = 10 + (index - (lines.length-1)/2) * fontsize;
				if (align=="top")
					offset += fontsize -25 - rect.height/2;
				ctx.fillText(line, rect.x+5, offset + rect.y+rect.height / 2, rect.width - 10);
			});
			
    
	},
    rotateCoords: function(rect){
    	var rotatedRect = JSON.parse(JSON.stringify(rect));
    
    	if (self.currentRotation == 270)
    	{
    		rotatedRect.x = rect.y ;
    		rotatedRect.y = -rect.x - rect.width;
    	}
    	if (self.currentRotation == 180)
    	{
    		rotatedRect.x = -rect.x - rect.width;
    		rotatedRect.y = -rect.y - rect.height;
    	}
    	if (self.currentRotation == 90)
    	{
    		rotatedRect.x = -rect.y - rect.height;
    		rotatedRect.y = rect.x;
    	}		
    	
    	return rotatedRect;
    },
    drawLine: function(from, to, colour)
    {
		  ctx.beginPath(); // begin
		
		  ctx.lineWidth = 10;
		  ctx.lineCap = 'round';
		  
		  ctx.strokeStyle = colour;
		  ctx.moveTo(from.x, from.y); // from
		  ctx.lineTo(to.x, to.y); // to
		
		  ctx.stroke(); // draw it!
    },
    recordLine: function(from, to)
    {
    	// Record for redraw, and send to the server too
    	// Ugh, can't stringify svgPoints for some reason...
    	var line = new Object();
    	line.from = new Object();
    	line.to = new Object();
    	line.from.x = from.x;
    	line.from.y = from.y;
    	line.to.x = to.x;
    	line.to.y = to.y;
    	line.colour = line.colour = this.$parent.colour.hex;
		if (self.lines.length > 1000)
		{		
			// Drop the first (i.e. oldest) lines
			self.lines.splice(0,self.lines.length-1000)
		}
		self.lines.push(line);	
    	self.sendCommand("draw", line)
    }, 
    sendCommand: function(command, data, extraid)
    {
    	if (ws)
    	{	
	    	if (ws.readyState == 1){
	    		
	    		var json = '{' + (extraid?'"extraid":' + JSON.stringify(extraid) + ',':'') + '"command":"' + command + '", "user":"' + self.$parent.userId + '", "game":"' + self.$parent.gameId + '", "data": ' + JSON.stringify(data) + '  }'
	    		console.log("Sending: " + json);
	    		ws.send(json);	
	    	}
	    	else
	    	{
	    		console.log("Can't send command '" + command + "', websocket state is : " +ws.readyState);
	    	}
	    }
    },
    makeid : function (length) {
	   var result           = '';
	   var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	   var charactersLength = characters.length;
	   for ( var i = 0; i < length; i++ ) {
	      result += characters.charAt(Math.floor(Math.random() * charactersLength));
	   }
	   return result;
	},
	dice : function(sides){
	 return (Math.floor(Math.random() * sides) + 1);
	},
    getLineLength : function(from, to)
    {
    	var x = 0;
    	var y=0;
    	if (from && to)
    	{
    		x = Math.pow(from.x - to.x, 2);
    		y = Math.pow(from.y - to.y, 2);
    	}
    	
    	return Math.pow(x+y, 0.5);
    },
    findClickedRect : function(pt)
    {
    	// Given a point, is there a rectangle that encloses that point?
    	return self.rectangles.find(function (rect){
    		if (rect.x < pt.x && rect.x + rect.width > pt.x && rect.y < pt.y && rect.y + rect.height > pt.y && rect.location=="board")
    		{
    			return true;
    		}
    	});
    },
    drawCard : function(rect)
    {
    	// Ask the server for the next in this deck - it will send back a message to all clients as to what happened
    	if (rect.cardsDrawn!="0" && rect.cardsDrawn!="pick")
    	{
    		this.sendCommand("drawcard", rect);
    	}       	  		    
    },
    viewDeck : function(rect)
    {
    	if (rect.viewMode!="0")
    	{
	    	this.currentdeck = {"label":"none"};
	    	// Ask the server to show the contents of this deck, in the deck flyin...
	    	this.sendCommand("viewdeck", rect);
	    }	
    },
    rollDice : function(rect)
    {   
    	var result = "";
    	var total = 0;
    	var clue = 0;
    	var legion = 0;
    	var special = 0; 
    	for (var i=0; i<rect.numDice; i++)
    	{
	    	if (rect.diceType=="d6"){
	    		var n = this.dice(6);
	    		total += n;
	    		result += n + ".";
	    	}
	    	if (rect.diceType=="pan"){
	    		var roll = this.dice(6);
	    		if (roll == 1 || roll ==2){
	    			total += 1;
	    		}
	    		else if (roll == 3) {
	    			total += 1;
	    			legion += 1;
	    		}
	    		else if (roll == 4) {
	    			total += 2;
	    			legion += 1;
	    		}
	    		else if (roll == 5) {
	    			legion += 1;
	    		}
	    		else if (roll == 6) {
	    			special += 1;
	    		}
	    		
	    	}
	    	if (rect.diceType=="lotr"){
	    		var roll = this.dice(6);
	    		if (roll <= 3 ){
	    			result = "Move " + roll + " steps towards the dark";
	    		}
	    		else if (roll == 4) {
					result = "Sauron moves 1";	    	
	    		}
	    		else if (roll == 5) {	
	    			result = "Discard any 2 cards";
	    		}
	    		else if (roll == 6) {	    			
	    			result = "Nothing happens";
	    		}		
	    	}
	    	if (rect.diceType=="lotr-ring"){
	    		var roll = this.dice(6);
	    		if (roll <= 3 ){
	    			result = 4 - roll + " steps";
	    		}
	    		else if (roll == 4) {
					result = "3 steps";	    	
	    		}
	    		else if (roll == 5) {	
	    			result = "2 steps";
	    		}
	    		else if (roll == 6) {	    			
	    			result = "4 steps";
	    		}		
	    	}
	    	if (rect.diceType=="d8"){
	    		var n = this.dice(8);
	    		total += n;
	    		result += n + ".";
	    	}
	    	if (rect.diceType=="mom"){
	    		var roll = this.dice(8);
	    		if (roll<4){
	    			result += "+";
	    			total +=1;
	    		}
	    		else if (roll<6){
	    			result += "?";
	    			clue ++;
	    		}
	    		else 
	    			result +="-"
	    	}
	    	if (rect.diceType=="d10"){
	    		var n = this.dice(10);
	    		total += n;
	    		result += n + ".";
	    	}
    	}
    	
    	if (rect.diceType == "mom")
    	{
    		result += " => " + total + " to " + (total + clue);     		
    	}
    	else if (rect.diceType == "pan")
    	{
    		result += " => ";
    		if (total)
    		 result += "-" + total + " barbarian ";
    		if (legion) 
    			result += " -" + legion + " legion "
    		if (special)
    			result += special + " special ";
    	}
    	else if (rect.diceType != "lotr" && rect.diceType != "lotr-ring")
    	{
    		result += " = " + total; 
    	}
    	
    	var toast = {"type":"error", "duration":60000, "message":self.$parent.userId + ' rolled ' + rect.label + " [" + rect.numDice + ' dice' + "]: \r\n" + result};
	    this.sendCommand("toast", toast);       	  	
	    this.$toast.open(toast);
    },
    showDialog : function(rect)
    {   
    	// Given a rectangle, show the relevant dialog based on it's type
		if (rect.type=="label")
      		self.modalEditItem = true;
      	if (rect.type=="dice")
      		self.modalEditDice = true;
      	if (rect.type=="counter")
      		self.modalEditCounter = true;
      	if (rect.type=="deck")
      		self.modalEditDeck = true;
          		
    },
    showPresetDialog:function(){
    	self.$bvModal.show('bv-modal-preset')
    },
    makeNewRect : function(clickpoint)
    {
    	var newRect ={};
    	if (clickpoint)
    	{
	      	newRect.x = clickpoint.x;          	
	      	newRect.y = clickpoint.y;
	      	newRect.location = "board";
	    }
	    else {
	     	newRect.x = 0;          	
	      	newRect.y = 0;	      	
	      	newRect.location = "player";
	    }
      	newRect.width=200;
      	newRect.height=200;
      	newRect.label = "";
      	newRect.description = "";	//	Only for label types
      	newRect.type=self.drawMode;
      	newRect.id = self.makeid(5);
      	newRect.count=0;
      	newRect.limit=0;
      	newRect.owner = self.$parent.userId;
      	self.rectangles.push(newRect);
        return newRect;
    },
    incrementCounter: function(rect)
    {
    	rect.count++;
	    this.doToast(this.$parent.userId + ' added a ' + rect.label + " [" + rect.count + "]");
	},
	decrementCounter: function(rect)
    {
   		rect.count--;
	    this.doToast(this.$parent.userId + ' removed a ' + rect.label + " [" + rect.count + "]");	
	},
	doToast: function(message)
	{
		var toast = {"type":"info", "duration":10000, "message":message};
        this.sendCommand("toast", toast);       	  	
		this.$toast.open(toast);
	},
    loadCanvas: function()
	{
		canvas = this.$refs.device;
		if (!canvas)
			console.log("No canvas found! Things will go bad very soon");
		canvas.width = window.innerWidth - 10;
		canvas.height = window.innerHeight - 40;
		
	    canvas.addEventListener('contextmenu', event => event.preventDefault());
		ctx = canvas.getContext('2d');
		//ctx.translate(100,100);
		trackTransforms(ctx);
	    

      var lastX=canvas.width/2, lastY=canvas.height/2;

      var dragStart,dragged;
      var drawStart, drawLatest;
      var rectdragStart;
      

	  // Touch support. Pinch support seems tricky, as it also means zoom to the browser
	  canvas.addEventListener("touchstart", function (evt){	  
	  
	  	var touches = evt.changedTouches;
 	  	// One touch = pan
 	  	if (touches.length == 1)
 	  	{
 	  	  var touch = touches[0];
          //console.log("touchstart: [" + touch.clientX + "," + touch.clientY+"]" );
        
	      lastX = touch.clientX || (evt.pageX - canvas.offsetLeft);
          lastY = touch.clientY || (evt.pageY - canvas.offsetTop);
          if (self.drawMode=='pen')
          {
	          drawStart = ctx.transformedPoint(lastX,lastY);    
	          drawLatest = drawStart;      	  
          }
          else
          {          
	          var rect = self.findClickedRect(ctx.transformedPoint(lastX,lastY))
		      dragged = false;
	      	  if (!rect)
	      	  {           
		          dragStart = ctx.transformedPoint(lastX,lastY);
		      }
		      else {
		      	  dragStart = null;
		      	  rectdragStart = ctx.transformedPoint(lastX,lastY);	 
		      	  rectdragStart.x -= rect.x;
		      	  rectdragStart.y -= rect.y;    
		      	  self.rectBeingMoved = rect;
		      	  self.redrawCanvas();
		      }	
	      }
        }        	  
	  }, false);

      canvas.addEventListener('touchmove',function(evt){   
      	 var touches = evt.changedTouches;
 	  	// Only look at first touch
 	  	for (var i = 0; i < touches.length && i<1; i++) {
 	  	  var touch = touches[i];
          //console.log("touchmove: [" + touch.clientX + "," + touch.clientY+"]" );
      	
          lastX = touch.clientX || (evt.pageX - canvas.offsetLeft);
          lastY = touch.clientY || (evt.pageY - canvas.offsetTop);
          var pt = ctx.transformedPoint(lastX,lastY);
          if (self.drawMode=="pen")
          {
              if (self.getLineLength(drawLatest, pt) > 20)
		      {	          	
	          	self.drawLine(drawLatest, pt, self.$parent.colour.hex);
	          	self.recordLine(drawLatest, pt);
	          	drawLatest = pt;
	        }
		      
          }
          else
          {
	          dragged = true;
	          // What are we dragging?
	          if (dragStart){
	          	// The whole canvas
	            var pt = ctx.transformedPoint(lastX,lastY);
	            ctx.translate(pt.x-dragStart.x,pt.y-dragStart.y);
	            self.redrawCanvas();
	          }
	          if (rectdragStart)
	          {
	          	// Just moving one rectangle
	            var pt = ctx.transformedPoint(lastX,lastY);
	            self.rectBeingMoved.x = pt.x-rectdragStart.x;
	            self.rectBeingMoved.y = pt.y-rectdragStart.y;
	            self.redrawCanvas();
	          }
          } 
		}     
      },false);


 	  canvas.addEventListener('touchend',function(evt){
 	  	var touches = evt.changedTouches;
 	  	// Only look at first touch
 	  	for (var i = 0; i < touches.length && i<1; i++) {
 	  	
 	  	  var touch = touches[i];
          //console.log("touchend: [" + touch.clientX + "," + touch.clientY+"]" );
        
       	  dragStart = null;
       	  rectdragStart = null;
       	  if (self.rectBeingMoved)
       	  {
       	  	self.rectBeingMoved.isBeingDragged = false;
       	  	self.rectBeingMoved = null;
       		self.redrawCanvas();                         	
       	  }       	  
       	  
          if (!dragged) zoom(evt.shiftKey ? -1 : 1 );
         }
      },false);

      // Mouse support

      canvas.addEventListener('mousedown',function(evt){
      //console.log("mousedown: [" + evt.offsetX + "," + evt.offsetY+"], button:" + evt.button );
      document.body.style.mozUserSelect = document.body.style.webkitUserSelect = document.body.style.userSelect = 'none';
      lastX = evt.offsetX || (evt.pageX - canvas.offsetLeft);
      lastY = evt.offsetY || (evt.pageY - canvas.offsetTop);
      
      // Start a drag with the LMB only
      if (evt.button === 0) {
          if (self.drawMode == "label" || self.drawMode == "dice" || self.drawMode == "counter" || self.drawMode=="deck")
          {
          	// Adding a new rectangle, which has a type which controls what it does
          	var clickpoint = ctx.transformedPoint(lastX,lastY);
          	var newRect = self.makeNewRect(clickpoint);

          	self.redrawCanvas();
          	self.selectedRect = newRect;
 			self.showDialog(newRect);
 			self.setDrawMode('');
          }else
          { 
          	  // Have we clicked on a rect?
	      	  var rect = self.findClickedRect(ctx.transformedPoint(lastX,lastY))
		      dragged = false;
	      	  if (!rect)
	      	  {           
	      	  	// Nope, we're dragging
		          dragStart = ctx.transformedPoint(lastX,lastY);
		          self.selectedRect = null;   	          
		      }
		      else {	      	  
		      		// Yes, move the rect
		      	  rectdragStart = ctx.transformedPoint(lastX,lastY);	 
		      	  rectdragStart.x -= rect.x;
		      	  rectdragStart.y -= rect.y;    
		      	  self.rectBeingMoved = rect;	
		      	  // Also select in case we're about to doubleclick
		      	  self.selectedRect = rect;      	 
		      }	
	      }
        }
        else{
         	// Use RMB to start drawing without using the button
        	self.setDrawMode("pen");
        }
        
        if (self.drawMode=="pen")
        {
            drawStart = ctx.transformedPoint(lastX,lastY);
        	drawLatest = drawStart;        
        }
      },false);

      canvas.addEventListener('mousemove',function(evt){       
          lastX = evt.offsetX || (evt.pageX - canvas.offsetLeft);
          lastY = evt.offsetY || (evt.pageY - canvas.offsetTop);
          
          if (self.drawMode=="pen")
          {
          	var pt = ctx.transformedPoint(lastX,lastY);	  
          	// Optimisation - only draw line segments once they're a certain length
          	if (self.getLineLength(drawLatest, pt) > 20)
          	{	          	
	          	self.drawLine(drawLatest, pt, self.$parent.colour.hex);
	          	self.recordLine(drawLatest, pt);
	          	drawLatest = pt;
	        }
          }
          else
          {
	          dragged = true;
	          // What are we dragging?
	          if (dragStart){
	          	// The whole canvas
	            var pt = ctx.transformedPoint(lastX,lastY);
	            ctx.translate(pt.x-dragStart.x,pt.y-dragStart.y);
	            self.redrawCanvas();
	          }
	          if (rectdragStart)
	          {
	          	// Just moving one rectangle
	          	self.rectBeingMoved.isBeingDragged = true;
	          	//if (self.rectBeingMoved.type == "deck")
	          	//{
	          		//self.currentdeck = self.rectBeingMoved;
	          	//}
	            var pt = ctx.transformedPoint(lastX,lastY);
	            self.rectBeingMoved.x = pt.x-rectdragStart.x;
	            self.rectBeingMoved.y = pt.y-rectdragStart.y;
	            self.redrawCanvas();
	          }
	     }       
      },false);

      canvas.addEventListener('mouseup',function(evt){
          //console.log("mouseup: [" + evt.offsetX + "," + evt.offsetY+"]");
          

       	  dragStart = null;
       	  rectdragStart = null;
       	

          // Have we clicked on a rect?
          var clickedPoint = ctx.transformedPoint(evt.offsetX,evt.offsetY);
	      var rect = self.findClickedRect(clickedPoint)
	      if (rect && !rect.isBeingDragged){	      
	      
	      	if (rect.type=="dice"){
	      		self.rollDice(rect);	      		
	      		return;
	      	}
	      	
	      	// Buttons are in the relevant quadrant
	      	var quadrant = 0;	// 0 = topleft, 1=topright, 2=bottomright, 3=bottomleft
	      	
	      	
	      	if (clickedPoint.y < rect.y + rect.height/2)
	      	{
	      		if (clickedPoint.x < rect.x + rect.width/2){
	      			quadrant = 0;
	      		}
	      		else {
	      			quadrant = 1;
	      		}
	      	}
	      	else {
	      		if (clickedPoint.x < rect.x + rect.width/2){
	      			quadrant = 3;
	      		}
	      		else{
	      			quadrant = 2;
	      		}	      
	      	}	
	      	//console.log("prerotate quadrant = " + quadrant + " rotate=" + self.currentRotation);
	      	// And deal with rotation
	      	if (self.currentRotation == 90){
	      		quadrant += 1;
	      	}
	      	if (self.currentRotation == 180){
	      		quadrant += 2;
	      	}	
	      	if (self.currentRotation == 270){
	      		quadrant += 3;
	      	}
	      	if (quadrant >=4){
	      		quadrant -= 4;
	      	}
	      	//console.log("quadrant = " + quadrant);
	      	
	      	if (rect.type=="counter"){
	      		// Did we click on a button?
				if (quadrant == 3){      	
					self.incrementCounter(rect);
					self.selectedRect = null;	// Prevent doubleclick dialog button 
      			}   				
	      		if (quadrant == 2) {      	
					self.decrementCounter(rect);
					self.selectedRect = null;	// Prevent doubleclick dialog button 
      			}	      		
      			self.redrawCanvas();
      			return;
	      	}
	      	else if (rect.type=="deck"){
	      		// Did we click on a button?
				if (quadrant == 3)  {    	
					self.drawCard(rect);
					self.selectedRect = null;	// Prevent doubleclick dialog button 
      			}	      				
	      		if (quadrant == 2) {      	
					self.viewDeck(rect);
					self.selectedRect = null;	// Prevent doubleclick dialog button 
      			}
      			self.redrawCanvas();
      			return;
          	}	      
	      }
          
          // Are we moving the rect instead?
          if (self.rectBeingMoved)
       	  {
       	  	self.rectBeingMoved.isBeingDragged = false;
       	  	self.sendCommand("updaterectangle", self.rectBeingMoved);
       	  	self.rectBeingMoved = null;
       		self.redrawCanvas();                         	
       	  }
          
       	  // Zoom in on click, if not dragging or drawing
          if (!dragged && self.drawMode=='' && !rect) zoom(evt.button==0 ? 1 : -1 );
          
          if (self.drawMode=="pen")
          {
            drawStart = null;
            drawLatest = null;
			self.redrawCanvas();               
          }
          
          // Clear drawing flag if RMB
          if (evt.button === 2) {
          	self.setDrawMode('');
          }
         
      },false);
      
      canvas.addEventListener('dblclick', function(evt){
      	//console.log("mouse dblclick: [" + evt.offsetX + "," + evt.offsetY+"]");
      	// Do we have a label selected?
      	if (self.selectedRect)
      	{	
      		self.showDialog(self.selectedRect);
      	}
      	else
      	{
      		// Never zoom if you're on a rect
      		var rect = self.findClickedRect(ctx.transformedPoint(evt.offsetX,evt.offsetY))
      		if (!rect){
      			zoom( -10 );
      		}
      	}
      },false);
      canvas.addEventListener('click', function(evt){
      	//console.log("mouse click: [" + evt.offsetX + "," + evt.offsetY+"]");
      	
      },false);

      var scaleFactor = 1.1;

      var zoom = function(clicks){
          var pt = ctx.transformedPoint(lastX,lastY);
          ctx.translate(pt.x,pt.y);
          var factor = Math.pow(scaleFactor,clicks);
          ctx.scale(factor,factor);
          ctx.translate(-pt.x,-pt.y);
          self.redrawCanvas();
      }

      var handleScroll = function(evt){
      	  
          var delta = evt.wheelDelta ? evt.wheelDelta/40 : evt.detail ? -evt.detail : 0;
          //console.log("mousescroll: [" + delta +"]");
          if (delta) zoom(delta);
          return evt.preventDefault() && false;
      };
    
      canvas.addEventListener('DOMMouseScroll',handleScroll,false);
      canvas.addEventListener('mousewheel',handleScroll,false);
	

	
	// Adds ctx.getTransform() - returns an SVGMatrix
	// Adds ctx.transformedPoint(x,y) - returns an SVGPoint
	function trackTransforms(ctx){
      var svg = document.createElementNS("http://www.w3.org/2000/svg",'svg');
      var xform = svg.createSVGMatrix();
      ctx.getTransform = function(){ return xform; };

      var savedTransforms = [];
      var save = ctx.save;
      ctx.save = function(){
          savedTransforms.push(xform.translate(0,0));
          return save.call(ctx);
      };
    
      var restore = ctx.restore;
      ctx.restore = function(){
        xform = savedTransforms.pop();
        return restore.call(ctx);
		      };

      var scale = ctx.scale;
      ctx.scale = function(sx,sy){
        xform = xform.scaleNonUniform(sx,sy);
        return scale.call(ctx,sx,sy);
		      };
    
      var rotate = ctx.rotate;
      ctx.rotate = function(radians){
          xform = xform.rotate(radians*180/Math.PI);
          return rotate.call(ctx,radians);
      };
    
      var translate = ctx.translate;
      ctx.translate = function(dx,dy){
          xform = xform.translate(dx,dy);
          return translate.call(ctx,dx,dy);
      };
    
      var transform = ctx.transform;
      ctx.transform = function(a,b,c,d,e,f){
          var m2 = svg.createSVGMatrix();
          m2.a=a; m2.b=b; m2.c=c; m2.d=d; m2.e=e; m2.f=f;
          xform = xform.multiply(m2);
          return transform.call(ctx,a,b,c,d,e,f);
      };
    
      var setTransform = ctx.setTransform;
      ctx.setTransform = function(a,b,c,d,e,f){
          xform.a = a;
          xform.b = b;
          xform.c = c;
          xform.d = d;
          xform.e = e;
          xform.f = f;
          return setTransform.call(ctx,a,b,c,d,e,f);
      };
    
      var pt  = svg.createSVGPoint();
      ctx.transformedPoint = function(x,y){
          pt.x=x; pt.y=y;
          return pt.matrixTransform(xform.inverse());
      }
	}
}
}
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- 	#mainscreen {position: relative;} -->

<style>
	body {font:"verdana"}
	.menuitem {margin-left:10px; margin-right:10px;}
	.menuitem img{height: 32px;  margin-top:2px;}
	.menubar {height:40px;background:#fff; border:1px solid lightgrey; background-color:#eee;}
	.padded {margin-left:10px; margin-right:5px; }
	.clickable {border: 1px solid; border-color: #ddd; background-color:white;}
	.menutext{font-size:75%; font-weight: 200; padding-bottom:20px}
	.rightmenu {float:right}
	.leftmenu {float:left}
	.midmenu {margin:auto}
	#sidebar-player {top:40px;}
	#sidebar-deck {top:40px;}	
	.card-header {padding:0px !important;}
	.card-body {padding:0.25em !important;}
	.card-text {font-size:1.5vw;}
	.card-text-description {font-size:0.8vw;}
	.card-image {width:300px;}
	#playerarea {width:400px;}
	#playerarea.subtext {font-size:0.4vw;}
</style>

<style scoped>
	body {margin:0px;}
	#rejoin {background-color: greenyellow; float:left; font-size:150%; font-weight:bold; margin:2px;}
	#mainscreen {position: relative;}
	canvas { display:block; margin:0px auto; background:#eee; }
	.inactive {color:red}
</style>
